export const UserGroup = () => import("./UserGroup.vue");
